import { gql } from '@apollo/client';
const GET_MODEL_PROJECTION = gql `
  query GetModelProjection($modelSpecificationProjectionId: ID!) {
    node(id: $modelSpecificationProjectionId) {
      ... on ModelSpecificationProjectionNode {
        id
        name
        number
        picture
        points {
          edges {
            node {
              id
              x
              y
              note
              noteX
              noteY
              photoNumber
              isVisible
              typeCode
              photo
              component {
                id
                name
                productCategory {
                  id
                  type
                  typeLabelPL
                  typeLabelEN
                  typeIcon
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_MODEL_PROJECTION;
